import { Button } from "@design-system/Button/Button";
import { Loader } from "@design-system/Loader/Loader";
import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { signInAgain } from "@components/counterparty/tin/signInAgain";
import { useForm1099NecTinExport } from "./useForm1099NecTinExport";

interface Form1099NecTinExportButtonProps {
    taxYear: number;
    entityId: number | undefined;
    disabled: boolean;
}

export const Form1099NecTinExportButton = ({
    taxYear,
    entityId,
    disabled,
}: Form1099NecTinExportButtonProps) => {
    const {
        isAvailable,
        isMinting,
        isDownloading,
        isStepUpRequired,
        exportWithTins,
        dismissStepUp,
    } = useForm1099NecTinExport({ taxYear, entityId });

    if (!isAvailable) {
        return null;
    }

    return (
        <>
            <Tooltip content="Export Track1099 CSV with tax IDs">
                <Button
                    type="button"
                    variant="secondary"
                    size="md"
                    disabled={
                        disabled ||
                        entityId === undefined ||
                        isMinting ||
                        isDownloading
                    }
                    onClick={exportWithTins}
                >
                    {isMinting ? <Loader inline /> : "Export with tax IDs"}
                </Button>
            </Tooltip>
            <ConfirmationModal
                show={isStepUpRequired}
                title="Sign in again"
                question="Sign in again to export tax IDs."
                yes="Sign in again"
                no="Cancel"
                onConfirm={signInAgain}
                onReject={dismissStepUp}
                onHide={dismissStepUp}
            />
        </>
    );
};
